const products = {
  name: 'Product Name',
  name_en: 'Product Name',
  name_fr: 'Product Name',
};

export default products;
